import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Link } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme, Container, Box, Tabs, Tab, Button } from '@mui/material';
import axios from 'axios';
import ClientManager from './components/ClientManager';
import RankingsView from './components/RankingsView';
import Login from './components/Login';
import CompetitorAnalysis from './components/CompetitorAnalysis';

const theme = createTheme({
  palette: {
    mode: 'light',
  },
});

function TabPanel() {
  const location = useLocation();
  const [value, setValue] = useState(0);

  useEffect(() => {
    setValue(location.pathname === '/rankings' ? 1 : 0);
  }, [location]);

  // Function to handle logout
  const handleLogout = () => {
    localStorage.removeItem('seoTrackerAuthenticated');
    localStorage.removeItem('seoTrackerToken');
    window.location.reload();
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mb: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
        <Button 
          variant="outlined" 
          size="small" 
          onClick={handleLogout}
        >
          Logout
        </Button>
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} centered>
          <Tab label="Clients" component={Link} to="/" />
          <Tab label="Rankings" component={Link} to="/rankings" />
        </Tabs>
      </Box>
    </Box>
  );
}

// Configure axios to use the JWT token for all requests
const setupAxiosInterceptors = () => {
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('seoTrackerToken');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  // Check if user is authenticated on component mount
  useEffect(() => {
    const authStatus = localStorage.getItem('seoTrackerAuthenticated');
    const token = localStorage.getItem('seoTrackerToken');
    
    // Only consider authenticated if both flag and token exist
    setIsAuthenticated(authStatus === 'true' && !!token);
    
    // Setup axios interceptors for JWT token
    setupAxiosInterceptors();
  }, []);

  // Handle successful login
  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Container>
          {isAuthenticated ? (
            <>
              <TabPanel />
              <Routes>
                <Route path="/" element={<ClientManager />} />
                <Route path="/rankings" element={<RankingsView />} />
                <Route path="/products/:productId/competitor-analysis" element={<CompetitorAnalysis />} />
                <Route path="*" element={<ClientManager />} />
              </Routes>
            </>
          ) : (
            <Login onLogin={handleLogin} />
          )}
        </Container>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
